import { Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import { nonames, state_array, nameRegExp } from "../../variables/Variables";

export default function LegalInformation({ state, onChange }) {
  function handleChange(event) {
    const { id, value } = event.target;
    const inputElement = document.getElementById(id);
    const errorElement = inputElement.nextSibling;

    if (id === "legalName") {
      if (value.trim().length === 0) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Legal Name can't be empty";
        errorElement.style.display = "block";
      } else if (!/^[ a-zA-Z0-9&-]+$/.test(value)) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML = "The Legal Name could contain only letters, numbers and & - symbols";
        errorElement.style.display = "block";
      } else if (!nameRegExp.test(value.trim()) || nonames.includes(value.trim().toLowerCase())) {
        inputElement.classList.add("is-invalid");
        errorElement.innerHTML =
          "The Legal Name may not contain an ending such as 'LLC', 'LC', 'PLLC', 'PA', 'Corp', or 'Inc'.";
        errorElement.style.display = "block";
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    if (id === "dbaname") {
      if (value.trim().length !== 0) {
        if (!/^[ a-zA-Z0-9&-]+$/.test(value)) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML = "The DBA could contain only letters, numbers and & - symbols";
          errorElement.style.display = "block";
        } else if (!nameRegExp.test(value.trim()) || nonames.includes(value.trim().toLowerCase())) {
          inputElement.classList.add("is-invalid");
          errorElement.innerHTML =
            "The DBA may not contain an ending such as 'LLC', 'LC', 'PLLC', 'PA', 'Corp', or 'Inc'.";
          errorElement.style.display = "block";
        } else {
          errorElement.style.display = "none";
          inputElement.classList.remove("is-invalid");
        }
      } else {
        errorElement.style.display = "none";
        inputElement.classList.remove("is-invalid");
      }
    }

    onChange(event);
  }

  return (
    <>
      <h5>Legal information</h5>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Legal Name of Corporation</strong>
            <br />
            The only punctuation and special characters allowed are hyphen (-) and ampersand (&).
            <br />
            <br />
            The legal name may not contain any of the following endings: LLC, PLLC, LC.
          </Tooltip>
        }
      >
        <Form.Group controlId="legalName">
          <Form.Label>Name of the Corporation</Form.Label>
          <Form.Control
            required
            data-hj-allow
            type="text"
            placeholder="Name"
            pattern="(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+$"
            maxLength="70"
            value={state && state.legalName ? state.legalName : ""}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">Please provide a valid corporation name</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>Trade Name / Doing Business As</strong>
            <br />
            A trade name or doing business as name is another name under which the business or individual operates.
            These names are identified by the terms &apos;trading as&apos; (TA), &apos;doing business as&apos; (DBA), or &apos;also known as&apos;
            (AKA). To file for a DBA, a separate filing with your state and county must be completed. We will send you
            instructions on how to complete this process.
            <br />
            <br />
            The trade name may not contain an ending such as &apos;LLC&apos;, &apos;LC&apos;, &apos;PLLC&apos;, &apos;PA&apos;, &apos;Corp&apos;, or &apos;Inc&apos;. To the
            existing Help Box.
          </Tooltip>
        }
      >
        <Form.Group controlId="dbaname">
          <Form.Label>DBA (Doing Business As)</Form.Label>
          <Form.Control
            data-hj-allow
            type="text"
            placeholder="Optional"
            pattern="((?!.*(?:[ ][lL][cC]$))(?!.*(?:[ ][lL][lL][cC]$))(?!.*(?:[ ][pP][lL][lL][cC]$))(?!.*(?:[ ][pP][aA]$))(?!.*(?:[ ][cC][oO][rR][pP]$))(?!.*(?:[ ][iI][nN][cC]$))^[ a-zA-Z0-9\\&-]+)$"
            maxLength="35"
            value={state && state.dbaname ? state.dbaname : ""}
            onChange={handleChange}
          />
          <Form.Control.Feedback type="invalid">Please provide a valid DBA</Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
      <OverlayTrigger
        rootClose
        placement="right-start"
        overlay={
          <Tooltip id="overlay-example" className="helpTooltip">
            <strong>State/Territory where Articles of Incorporation are (or will be) filed</strong>
            <br />
            Articles of incorporation must be filed with a state for a business to incorporate. To file, an applicant
            generally must include the name and address of the corporation, its general purpose, and the number and type
            of shares of stock to be issued. Each state has its own system of approval of articles, prohibits names
            which are confusingly similar to those of existing corporations, sets specific requirements for non-profits
            (charitable, religious, educational, public benefit, and so forth), and regulates the issuance of shares of
            stock.
          </Tooltip>
        }
      >
        <Form.Group controlId="organizedState">
          <Form.Label>State Organized</Form.Label>
          <Form.Control
            required
            as="select"
            className="form-control"
            name="organizedState"
            value={state.organizedState}
            onChange={onChange}
          >
            <option value="">Select a state</option>
            {Object.keys(state_array).map((prop, key) => (
              <option key={key} value={prop}>
                {state_array[prop]}
              </option>
            ))}
          </Form.Control>
          <Form.Control.Feedback type="invalid">
            Please provide the state where the company was organized
          </Form.Control.Feedback>
        </Form.Group>
      </OverlayTrigger>
    </>
  );
}
